import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { EditLoadioStoreFeaturedSectionContent } from "administration/loadio/components";
import { observer } from "mobx-react";

function EditLoadioStoreFeaturedSectionContentModalTemplate({ modalParams, loaderStore, t }) {
    return (
        <MrbModal title={"Add new item"} modalParams={modalParams} t={t} className="modal__content modal__content--lrg">
            <p className="u-type--sml u-type--left u-mar--bottom--tny">Select from list</p>
            <EditLoadioStoreFeaturedSectionContent
                routeStore={modalParams.params.routeStore}
                item={modalParams.data.item}
                shouldAdd={modalParams.data.shouldAdd}
                addItem={modalParams.data.addItem}
                onUpdate={modalParams.close}
                loaderStore={loaderStore}
                cancel={modalParams.close}
            />
        </MrbModal>
    );
}

EditLoadioStoreFeaturedSectionContentModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default observer(EditLoadioStoreFeaturedSectionContentModalTemplate);
